import i18n from '../i18n';
import { apiFetch } from './apiClient';

// PersonalInformationUtils.js

// Function to fetch doctor (user), practice, and template information from the server
export const fetchPersonalInformation = async () => {
  try {
    const response = await apiFetch('/get-user-info', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Ensure cookies are sent with the request
      body: JSON.stringify({}),
    });

    if (!response.ok) {
      throw new Error(i18n.t('templates.loadInfoError'));
    }

    const data = await response.json();
    return {
      user_info: data.user_info,
      practice_info: data.practice_info,
      template_info: data.template_info, // Include template_info
    };
  } catch (error) {
    console.error('Error fetching personal information:', error);
    throw error;
  }
};

// Function to update doctor (user), practice, and template information on the server
export const updatePersonalInformation = async (user_info, practice_info, template_info) => {
  try {
    const response = await apiFetch('/update-user-info', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Ensure cookies are sent with the request
      body: JSON.stringify({ user_info, practice_info, template_info }), // Include template_info in the request body
    });

    if (!response.ok) {
      throw new Error(i18n.t('templates.saveInfoError'));
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating personal information:', error);
    throw error;
  }
};

// New template-related functions
export const fetchSavedTemplates = async () => {
  const response = await apiFetch('/get-saved-templates', {
    method: 'GET',
    credentials: 'include',
  });
  if (!response.ok) throw new Error(i18n.t('templates.loadError'));
  return response.json();
};

export const saveTemplate = async (name, template_data) => {
  const response = await apiFetch('/save-template', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ name, template_data })
  });
  if (!response.ok) throw new Error(i18n.t('templates.saveError'));
  return response.json();
};

export const deleteTemplate = async (templateId) => {
  const response = await apiFetch(`/delete-template/${templateId}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!response.ok) throw new Error(i18n.t('templates.deleteError'));
  return response.json();
};

// Password management function
export const setPassword = async (password) => {
  try {
    const response = await apiFetch('/auth/set-password', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Ensure cookies are sent with the request
      body: JSON.stringify({ password }),
    });

    if (!response.ok) {
      throw new Error(i18n.t('errors.password'));
    }

    return await response.json();
  } catch (error) {
    console.error('Error setting password:', error);
    throw error;
  }
};


export const getReferralCode = async () => {
  const response = await apiFetch('/api/generate-stripe-promo-code', {
    method: 'POST',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(i18n.t('account.referralError'));
  }

  return await response.json();
};
